
import {  FaArrowRight } from "react-icons/fa6";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faEnvelope,
  faPhone,
  faLocationDot,
  faPlay,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

function Home() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);


const services = [
  {
  id: "01",
  title: "Web Development",
  desc: "Responsive and scalable web applications using React.js, Vue.js, Angular, and Node.js.",
  icon: "assets/img/icons/service-icon1.svg",
  link: "/web-development", // 🔗 redirection link
},
{
  id: "02",
  title: "Mobile App Development",
  desc: "Native and cross-platform mobile apps for iOS & Android using Flutter and React Native.",
  icon: "assets/img/icons/service-icon2.svg",
  link: "/mobile-app-development", // 🔗 redirection link}
  },
  {
    id: "03",
    title: "Internet of Things (IoT)",
    desc: "End-to-end IoT architecture: devices, connectivity, cloud integration Data collection, monitoring dashboards",
    icon: "assets/img/icons/service-icon3.svg",
    link: "/internet-of-things",
  },
  {
    id: "04",
    title: "UI/UX & Digital Design",
    desc: "User research, prototyping, design systems, accessibility-focused design",
    icon: "assets/img/icons/service-icon4.svg",
    link: "/ui-ux-design",
  },
  {
    id: "05",
    title: "Digital Marketing",
    desc: "SEO(Search Engine Optimization) SEM(Search Engine Marketing) Social Media Integration Email Marketing",
    icon: "assets/img/icons/service-icon5.svg",
    link: "/digital-marketing",
  },
  {
    id: "06",
    title: "Cloud Solutions",
    desc: "Cloud migration, serverless architecture, and scalable infrastructure on AWS, Azure, and Google Cloud.",
    icon: "assets/img/icons/service-icon6.svg",
    link: "/cloud-solutions",
  }
];




  return (
   <>
      {/* ===== HERO AREA STARTS ===== */}
      <div
        className="hero1-section-area"
        style={{ backgroundImage: "url(/assets/img/all-images/bg/hero-bg1.png)" }}
      >
        <img src="/assets/img/elements/elements6.png" alt="" className="elements6" />
        <img src="/assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="/assets/img/elements/elements4.png" alt="" className="elements4" />

        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="hero1-header heading1">
                <h5 data-aos="fade-left" data-aos-duration="800">
                  <span>
                    <img src="/assets/img/icons/sub-logo1.svg" alt="sub-logo" />
                  </span>
                  Empowering Your Business with Smart Digital Solutions
                </h5>
                <div className="space16"></div>
                <h1 className="text-anime-style-3">
                  
                </h1>
                <div className="space16"></div>
                <p data-aos="fade-left" data-aos-duration="900">
                   Chester IT solutions Limited is global tech ally—transforming visionary ideas into impactful 
digital products using cutting-edge tools and methodologies. From ideation to deployment, 
we’ve partnered with businesses across industries to simplify operations with innovative 
mobile, web, AI, and IoT-enabled solutions.”
                </p>
                <div className="space32"></div>
                <div className="btn-area1" data-aos="fade-left" data-aos-duration="1000">
                  <a href="/services" className="vl-btn1">
                    Explore Our Solutions <FontAwesomeIcon icon={faArrowRight} className="i" />
                  </a>
                  <a href="/contact" className="vl-btn7">
                    Request a Free Consultation <FontAwesomeIcon icon={faArrowRight} className="i" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-1"></div>

            <div className="col-lg-5">
              <div className="hero-images-area">
                <div className="img1">
                  <img src="/assets/img/all-images/hero/hero-img1.png" alt="hero" />
                </div>
                <div className="image-bg1">
                  <img src="/assets/img/all-images/bg/img-bg1.svg" alt="bg" />
                </div>
                <div className="elements">
                  <img
                    src="/assets/img/elements/elements3.png"
                    alt=""
                    className="elements3 aniamtion-key-1"
                  />
                  <img
                    src="/assets/img/elements/elements2.png"
                    alt=""
                    className="elements2 aniamtion-key-2"
                  />
                  <img
                    src="/assets/img/elements/elements1.png"
                    alt=""
                    className="elements1 keyframe5"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===== HERO AREA ENDS ===== */}

      {/* ===== ABOUT AREA STARTS ===== */}
      <div className="about1-section-area sp1">
        <img src="/assets/img/elements/elements9.png" alt="" className="elements9" />
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-images-area">
                <img src="/assets/img/elements/elements10.png" alt="" className="elements10" />
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-6">
                    <div className="img1 image-anime reveal">
                      <img src="/assets/img/all-images/about/about-img1.png" alt="" />
                    </div>
                    <div className="space30 d-lg-none d-block"></div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="img1 image-anime reveal">
                      <img src="/assets/img/all-images/about/about-img2.png" alt="" />
                    </div>
                    <div className="space30"></div>
                    <div className="img1 image-anime reveal">
                      <img src="/assets/img/all-images/about/about-img3.png" alt="" />
                    </div>
                  </div>
                </div>
                <div className="check-icons aniamtion-key-1">
                  <img src="/assets/img/icons/check1.svg" alt="check" />
                  <p>With 15+ years of experience IT solution help community.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-1"></div>

            <div className="col-lg-5">
              <div className="about-header-area heading2">
                <h5>
                  <span>
                    <img src="/assets/img/icons/sub-logo1.svg" alt="sub-logo" />
                  </span>
                  About Chester IT Solution
                </h5>
                <div className="space24"></div>
                <h2 className="text-anime-style-3">
                  To Be Your Complete Digital Partner—From Strategy to Launch and Beyond
                </h2>
                <div className="space16"></div>
                <p data-aos="fade-left" data-aos-duration="800">
                 Over the past five years, we’ve collaborated with 50+ clients globally, crafting digital 
solutions that drive efficiency, innovation, and user engagement. Whether it’s building 
custom platforms, AI-powered tools, or enhancing existing systems, our mission is to fast
track your digital vision with precision and excellence.
                </p>
                <div className="space28"></div>

              <div className="row" data-aos="fade-left" data-aos-duration="900">
  {/* Agile methodology + certified professionals */}
  <div className="col-lg-6 col-md-6">
    <div className="progresbar text-center">
      <div className="icon-area mb-3">
        <i className="fa-solid fa-certificate fa-3x"></i>
      </div>
      <div className="content-area">
        <h6>Agile methodology + certified professionals</h6>
        <div className="space8"></div>
      </div>
    </div>
  </div>

  {/* Full-cycle capability */}
  <div className="col-lg-6 col-md-6">
    <div className="progresbar text-center">
      <div className="icon-area mb-3">
        <i className="fa-solid fa-diagram-project fa-3x"></i>
      </div>
      <div className="content-area">
        <h6>Full-cycle capability: strategy, design, development, QA, support</h6>
        <div className="space8"></div>
      </div>
    </div>
  </div>

  {/* Smooth team collaboration */}
  <div className="col-lg-6 col-md-6">
    <div className="progresbar text-center">
      <div className="icon-area mb-3">
        <i className="fa-solid fa-users fa-3x"></i>
      </div>
      <div className="content-area">
        <h6>Smooth team collaboration and knowledge-sharing</h6>
        <div className="space8"></div>
      </div>
    </div>
  </div>

  {/* Rapid turnaround */}
  <div className="col-lg-6 col-md-6">
    <div className="progresbar text-center">
      <div className="icon-area mb-3">
        <i className="fa-solid fa-bolt fa-2x me-2"></i>
        <i className="fa-solid fa-circle-check fa-2x"></i>
      </div>
      <div className="content-area">
        <h6>Rapid turnaround without compromising quality</h6>
        <div className="space8"></div>
      </div>
    </div>
  </div>
</div>


                <div className="space28"></div>
                <div className="btn-area1" data-aos="fade-left" data-aos-duration="1200">
                  <a href="/services" className="vl-btn2">
                    See How We Can Help <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===== ABOUT AREA ENDS ===== */}
       {/* ============ Services Section ============ */}
      <div
  className="service1-section-area sp2"
  style={{
    backgroundImage: "url(assets/img/all-images/bg/service-bg1.png)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  }}
>
  <div className="container">
    <div className="row">
      <div className="col-lg-6 m-auto text-center heading2 space-margin60">
        <h5>
          <span>
            <img src="assets/img/icons/sub-logo1.svg" alt="" />
          </span>
          Our Services
        </h5>
        <div className="space24"></div>
        <h2 className="text-anime-style-3">
          Expert IT Services Designed <br className="d-lg-block d-none" />{" "}
          To Elevate Your Business
        </h2>
      </div>
    </div>
  <div className="space32"></div>
    <div className="row">
      {services.map((service, index) => (
        <div
          className="col-lg-4 col-md-6"
          key={service.id}
          data-aos="zoom-in"
          data-aos-duration={800 + index * 100}
        >
          <a href={service.link}>
          <div className="service1-boxarea">
            <div className="icons">
              <img src={service.icon} alt={service.title} />
            </div>
            <div className="arrow">
              <a href={service.link}>
                <FontAwesomeIcon icon={faArrowRight} />
              </a>
            </div>
            <div className="space24"></div>
            <a href={service.link}>{service.title}</a>
            <div className="space16"></div>
            <p>{service.desc}</p>
            <div className="space24"></div>
            <h5>{service.id}</h5>
          </div>
          </a>
        </div>
      ))}
    </div>
  </div>
</div>


      {/* ============ Work Section ============ */}
      <div className="work1-section-area sp1">
        <img
          src="assets/img/elements/elements11.png"
          alt=""
          className="elements9"
        />
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="solution-header heading2">
                <h5>
                  <span>
                    <img src="assets/img/icons/sub-logo1.svg" alt="" />
                  </span>
                  best it solution
                </h5>
                <div className="space24"></div>
                <h2 className="text-anime-style-3">
                  End-to-End IT Solutions for Growing Businesses
                </h2>
                <div className="space16"></div>
                <p>
                  We provide comprehensive, end-to-end IT solutions designed to
                  support businesses at every stage of growing.
                </p>

                <div className="space24"></div>
                <div className="bg-progress">
                  <div className="progress-bar">
                    <label>
                      UI & UX <span>98%</span>
                    </label>
                    <div className="progress">
                      <div
                        className="progress-inner"
                        style={{ width: "98%" }}
                      ></div>
                    </div>
                  </div>

                  <div className="progress-bar">
                    <label>
                      Website Development <span>99%</span>
                    </label>
                    <div className="progress">
                      <div
                        className="progress-inner"
                        style={{ width: "99%" }}
                      ></div>
                    </div>
                  </div>

                  <div className="progress-bar">
                    <label>
                      Software Development <span>99%</span>
                    </label>
                    <div className="progress">
                      <div
                        className="progress-inner"
                        style={{ width: "99%" }}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="space32"></div>
                <div className="btn-area1">
                  <a href="/services" className="vl-btn2">
                    Discover Our Solutions{" "}
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-2"></div>

            <div className="col-lg-5">
              <div className="soultions-images">
                <img
                  src="assets/img/elements/elements10.png"
                  alt=""
                  className="elements10"
                />
                <div className="img1 reveal image-anime">
                  <img src="assets/img/all-images/work/work-img1.png" alt="" />
                </div>
                <div className="img2 reveal image-anime">
                  <img src="assets/img/all-images/work/work-img2.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
       <div className="work-others-section" style={{ backgroundImage: 'url(assets/img/all-images/bg/hero-bg11.png)', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="work-header heading1 text-center space-margin60">
                <h5>
                  <span>
                    <img src="assets/img/icons/sub-logo1.svg" alt="" />
                  </span>
                  How It's Work
                </h5>
                <div className="space24"></div>
                <h2 className="text-anime-style-3">Expert IT Services Designed To Elevate Your Business</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* WORK AREA ENDS */}

      {/* CASE AREA STARTS */}
        <div className="case1-section-area sp1">
        <div className="case-works-section-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="others-widget-area">
                  <div className="row align-items-center">
                    <div className="col-lg-4">
                      <div className="card-boxarea box1" data-aos="zoom-in" data-aos-duration="800">
                        <div className="div text-end">
                          <h3>01</h3>
                        </div>
                        <div className="content-area">
                          <a href="/services">Discovery Consultation</a>
                          <div className="space14"></div>
                          <p>With our intuitive interface and robust features, you buy, sell.</p>
                        </div>
                      </div>
                      <div className="space30"></div>
                      <div className="card-boxarea box2" data-aos="zoom-in" data-aos-duration="900">
                        <div className="content-area">
                          <a href="/services">Customized IT Strategy</a>
                          <div className="space14"></div>
                          <p>Plus, our commitment to the security means that PayCoin.</p>
                        </div>
                        <div className="div text-end">
                          <h3>02</h3>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="images" data-aos="zoom-in" data-aos-duration="1000">
                        <img src="assets/img/elements/elements12.png" alt="" className="elements12" />
                        <img src="assets/img/elements/elements13.png" alt="" className="elements13" />
                        <img src="assets/img/elements/elements14.png" alt="" className="elements14" />
                        <img src="assets/img/elements/elements15.png" alt="" className="elements15" />
                        <div className="img1">
                          <img src="assets/img/all-images/case/case-img4.png" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="card-boxarea box3" data-aos="zoom-in" data-aos-duration="800">
                        <div className="div">
                          <h3>03</h3>
                        </div>
                        <div className="content-area2">
                          <a href="/services">Quality Assurance</a>
                          <div className="space14"></div>
                          <p>Trusted partner in the world of crypto trading Join us today.</p>
                        </div>
                      </div>
                      <div className="space30"></div>
                      <div className="card-boxarea box4" data-aos="zoom-in" data-aos-duration="1000">
                        <div className="content-area2">
                          <a href="/services">24/7 Support</a>
                          <div className="space14"></div>
                          <p>Resources designed to help navigate best the dynamic</p>
                        </div>
                        <div className="div">
                          <h3>04</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* CASE AREA ENDS */}

        {/*===== TESTIMONIAL AREA STARTS =======*/}
      <div className="testimonial1-section-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 m-auto">
              <div
                className="testimonial-header text-center heading2 space-margin60"
                data-aos="fade-up"
              >
                <h5>
                  <span>
                    <img src="assets/img/icons/sub-logo1.svg" alt="" />
                  </span>
                  Testimonials
                </h5>
                <div className="space20"></div>
                <h2 className="text-anime-style-3">
                  Experience the Difference Through Our Clients' Eyes
                </h2>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Left Image */}
            <div className="col-lg-5">
              <div className="img1 image-anime reveal" data-aos="fade-right">
                <img
                  src="assets/img/all-images/testimonial/testimonial-img1.png"
                  alt=""
                />
              </div>
            </div>

            {/* Testimonial Slider with autoplay */}
            <div className="col-lg-6">
              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop={true}
                pagination={{ clickable: true }}
                className="slider-galeria"
                data-aos="fade-up"
              >
                {[2, 3, 4, 5, 2].map((num, idx) => (
                  <SwiperSlide key={idx}>
                    <div
                      className="testimonial-slider-content-area"
                      data-aos="zoom-in"
                    >
                      <div className="testimonial-author-area">
                        <ul>
                          {[...Array(5)].map((_, i) => (
                            <li key={i}>
                              <a href="">
                                <i className="fa-solid fa-star"></i>
                              </a>
                            </li>
                          ))}
                        </ul>
                        <div className="space16"></div>
                        <img
                          src="assets/img/icons/quito1.svg"
                          alt=""
                          className="quito1"
                        />
                        <img
                          src="assets/img/elements/elements18.png"
                          alt=""
                          className="elements18"
                        />
                        <p>
                          Partnering with ETech has transformed our IT
                          Solution. Their tailored solutions help streamline our
                          operations, improve cybersecurity, and drive
                          efficiency across the board. We've experienced fewer
                          disruptions, faster an.”
                        </p>
                      </div>
                      <div className="space60"></div>
                      <div className="testimonial-man-info-area">
                        <div className="man-images-text">
                          <div className="mans-img">
                            <img
                              src={`assets/img/all-images/testimonial/testimonial-img${num}.png`}
                              alt=""
                            />
                          </div>
                          <div className="man-text">
                            <a href="/">Ben Stokes</a>
                            <div className="space12"></div>
                            <p>Owner Taxfirm</p>
                          </div>
                        </div>
                        <img src="assets/img/elements/elements17.png" alt="" />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* Thumbnails */}
            <div className="col-lg-1">
              <div
                className="slider-galeria-thumbs text-center d-lg-block d-none"
                data-aos="fade-left"
              >
                {[2, 3, 4, 5].map((num, idx) => (
                  <div className="testimonial3-sliders-img" key={idx}>
                    <img
                      src={`assets/img/all-images/testimonial/testimonial-img${num}.png`}
                      alt=""
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== TESTIMONIAL AREA ENDS =======*/}

      {/*===== TEAM AREA STARTS =======*/}
   
      {/*===== TEAM AREA ENDS =======*/}
      
   </>
    
  )
}

export default Home;
